// frontend/src/lib/utils.js
// Updated: March 24, 2025
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}